import {Directive, EventEmitter, HostListener, Output} from "@angular/core";

@Directive({
	selector: '[cpDblClick]',
})
export class DblClickDirective {

	@Output() cpClick: EventEmitter<MouseEvent> = new EventEmitter<MouseEvent>();
	@Output() cpDblClick: EventEmitter<MouseEvent> = new EventEmitter<MouseEvent>();

	private readonly DELAY = 200;

	private timer;
	private prevent: boolean;

	@HostListener('click', ['$event'])
	private onClick(e: MouseEvent) {
		this.timer = setTimeout(() => {
			if (!this.prevent) {
				this.cpClick.emit(e);
			}
			this.prevent = false;
		}, this.DELAY);

	}

	@HostListener('dblclick', ['$event'])
	private onDblClick(e: MouseEvent) {
		clearTimeout(this.timer);
		this.prevent = true;
		this.cpDblClick.emit(e);
	}
}
